var _ = require('optimizely-client-fn');
var di = require('core/di');

var InterestGroupStore = di.get('stores/interest_group');

var Provider = require('./provider');
var Tracker = require('./tracker');

module.exports = function (PluginManager) {
  PluginManager.registerAudienceMatcher('predicted_intent', require('./matchers/predicted_intent'));

  // Register providers for all known InterestGroups. Note that these providers are assumed to
  // be sticky, meaning they won't be invoked if a given InterestGroup already has a score.
  _.forEach(InterestGroupStore.getAllIds(), function (id) {
    var provider = Provider.makeInterestGroupProvider(id);
    PluginManager.registerVisitorProfileProvider(provider);
  });

  PluginManager.registerAnalyticsTracker('interest_groups', Tracker);
};

